export const DEFAULT_PREFETCH_MAX_AGE = 10 * 1000;
